/**
 * Facts about a file the user picked, in the form a row renders.
 *
 * Shared because two features now screen uploads — registration images and
 * provenance documents — and a size that read '1.4 MB' on one and '1468006 B'
 * on the other would be two answers to one question.
 */

/** '1.4 MB'. Rounded, because a byte count is not what anyone is checking. */
export function describeBytes(bytes: number): string {
  if (bytes < 1024) return `${String(bytes)} B`;

  const kb = bytes / 1024;
  if (kb < 1024) return `${String(Math.round(kb))} KB`;

  return `${(kb / 1024).toFixed(1)} MB`;
}

/**
 * Name and size together, which is as close to identity as a File gets.
 *
 * Two different photographs matching on both is possible and a re-drop of the
 * same file is far likelier, so this errs towards calling it a duplicate — a
 * refusal the user can see and work around, rather than a second upload of the
 * same bytes they never notice.
 */
export function fileKey(file: File): string {
  return `${file.name}:${String(file.size)}`;
}
